import React, { useEffect } from "react";
import $ from "jquery";
import "magnific-popup";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Newsletter from "../components/Newsletter";
import Breadcrumbs from "../components/Breadcrumbs";
import { useLocation, useParams } from "react-router-dom";
import StructuredData from "../seo/StructuredData";
import { breadcrumbJsonLd } from "../seo/jsonld";
import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_URL } from "../seo/site";

export default function Gallery({ setHeader }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { slug } = useParams();
  
  const currentPath = window.location.pathname;
  let folderName = "";
  let length = 0;
  let padLength = 0;
  if (currentPath.includes("capital-plaza")) {
    folderName = "capital-plaza";
    length = 27;
    padLength = 2;
  } else if (currentPath.includes("podgorica")) {
    folderName = "podgorica";
    length = 20;
  } else if (currentPath.includes("porto-montenegro")) {
    folderName = "porto-montenegro";
    length = 12;
  }

  const imageSrcList = Array.from({ length: length }, (_, i) => {
    const imageIndex = i + 1;
    const fileName = padLength
      ? String(imageIndex).padStart(padLength, "0")
      : String(imageIndex);
    return `/assets/images/gallery/${folderName}/${fileName}.jpg`;
  });
  const pageLang = i18n?.language === "me" ? "me" : "en";
  const pageUrl = `${SITE_URL}${location.pathname}`;
  const pageTitle = `${t("header.gallery.pageTitle")} - ${SITE_NAME}`;
  const pageDescription = t("header.gallery.metaDescription");
  const enUrl = `${SITE_URL}/en/gallery/${slug || folderName}`;
  const meUrl = `${SITE_URL}/me/galerija/${slug || folderName}`;
  const breadcrumbItems = [
    { name: SITE_NAME, item: `${SITE_URL}/${pageLang}` },
    {
      name: t("header.gallery.pageTitle"),
      item:
        pageLang === "en" ? `${SITE_URL}/en/gallery` : `${SITE_URL}/me/galerija`,
    },
    { name: t("gallery"), item: pageUrl },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  useEffect(() => {
    $(".image-popup").magnificPopup({
      type: "image",
      callbacks: {
        beforeOpen: function () {
          this.st.image.markup = this.st.image.markup.replace(
            "mfp-figure",
            "mfp-figure animated zoomInDown"
          );
        },
      },
      gallery: {
        enabled: true,
      },
    });
  }, []);

  return (
    <>
      <Helmet htmlAttributes={{ lang: pageLang === "me" ? "sr-ME" : "en" }}>
        {/* <!-- meta tag --> */}
        <meta charSet="utf-8" />
        <title>
          {pageTitle}
        </title>

        {/* <!-- Meta Tags--> */}
        <meta
          name="description"
          content={pageDescription}
        />
        <meta
          name="keywords"
          content="durō, duro, niche perfumery, niche parfimerija,  parfimerija, galerija"
        />
        <meta name="author" content="intellect.se" />
        <link rel="canonical" href={pageUrl} />
        <link rel="alternate" href={enUrl} hrefLang="en" />
        <link rel="alternate" href={meUrl} hrefLang="sr-ME" />
        <link rel="alternate" href={meUrl} hrefLang="x-default" />

        {/* <!-- responsive tag --> */}
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* <!-- Facebook Metadata --> */}
        <meta property="og:type" content="website" />
        <meta property="og:image:height" content="1200" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
      </Helmet>
      <Loader />
      {/* <!-- Main content Start --> */}
      <div className="main-content lion-bg">
        {/* <!-- Breadcrumbs Start --> */}
        <div className={`rs-breadcrumbs ${currentPath.includes("podgorica") || currentPath.includes("capital-plaza") ? 'img12' : 'img10'}`}>
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("gallery")}
                {/*<span className="watermark">{gallery}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs />
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- Gallery Start --> */}
        <div className="container">
          <div className="row y-middle">
            <div className="rs-gallery style1 mt-60 mb-30">
              <div className="row no-gutters">
                {imageSrcList.map((img) => (
                  <div key={img} className="col-lg-3 col-md-6 col-sm-6">
                    <div className="gallery-item margin">
                      <div className="gallery-icon">
                        <a className="image-popup" href={img}>
                          <img src={img} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Gallery End --> */}

        {/* <!-- Newsletter section start --> */}
        <div className="rs-newsletter lion-bg style1 pt-90 md-pt-60 mb--65">
          <Newsletter />
        </div>
        {/* <!-- Newsletter section end --> */}
      </div>
      {/* <!-- Main content End --> */}
      <StructuredData data={breadcrumbJsonLd(breadcrumbItems)} />
    </>
  );
}
